export default __webpack_public_path__ + "static/media/photo--lg--54.6b84c842.jpg";